<template>
	<div class="link-tree-node" :class="classes">
		<div class="link-tree-node-content-wrapper">
			<div class="link-tree-node-space" :style="spaceStyles">&nbsp;</div>
			<div class="link-tree-node-content" @click="pl_clickNode">
				<slot :data="data" :level="level" :index="index"></slot>
			</div>
			<link-icon icon="link-icon-down" class="link-tree-node-icon" @click.stop="pl_clickIcon" v-if="existChildren"/>
		</div>
		<el-collapse-transition v-if="existChildren">
			<div v-show="node.expanded">
				<link-tree-node ref="children"
								v-for="(item,childIndex) in data[childrenKey]"
								:key="childIndex"
								:data="item"
								:label-key="labelKey"
								:children-key="childrenKey"
								:level="level+1"
								:nodeClass="nodeClass"
								:pnode="node"
								:levelSpace="levelSpace"
								:index="childIndex+1"
				>
					<template slot-scope="{data:nodeData,level,index:nodeIndex,parentIndex}">
						<slot :data="nodeData" :level="level" :index="`${index}.${nodeIndex}`"></slot>
					</template>
				</link-tree-node>
			</div>
		</el-collapse-transition>
	</div>
</template>

<script>
	import {TREE_PUB} from "./index";

	export default {
		name: "link-tree-node",
		props: {
			...TREE_PUB.pubProps,
			level: {type: Number},
			index: {type: Number},
			pnode: {},
		},
		inject: ['linkTree'],
		computed: {
			classes() {
				const ret = [
					`link-tree-node-level-${this.level}`,
					{
						'link-tree-expand': this.node.expanded,
					}
				]
				if (!!this.nodeClass) {
					if (this.$lv.$utils.typeOf(this.nodeClass) === 'string') {
						ret.push(this.nodeClass)
					} else {
						let cls = this.nodeClass(this.data)
						cls = this.$lv.$utils.typeOf(cls) === 'array' ? cls : [cls]
						!!cls && ret.push(...cls)
					}
				}
				return ret
			},
			existChildren() {
				return this.data[this.childrenKey] && this.data[this.childrenKey].length > 0
			},
			spaceStyles() {
				return {
					width: `${(this.level - 1) * this.levelSpace}px`
				}
			},
		},
		data() {
			return {
				node: {
					parent: this.pnode,
					expanded: false,
					data: this.data,
					level: this.level,
				},
			}
		},
		methods: {
			toggleExpand() {
				this.node.expanded = !this.node.expanded
			},
			pl_clickIcon() {
				this.toggleExpand()
			},
			pl_clickNode() {
				!!this.collapseOnClickNode && this.toggleExpand()
				this.linkTree.$emit('node-click', {node: this.node})
			},
		}
	}
</script>

<style lang="scss">
	.link-tree-node {
		user-select: none;
		cursor: pointer;

		.link-tree-node-icon {
			font-size: 12px;
		}

		& > .link-tree-node-content-wrapper {
			display: flex;
			flex-wrap: nowrap;
			align-items: center;
			width: 100%;
			padding: 0 16px;
			box-sizing: border-box;

			.link-tree-node-content {
				min-height: 32px;
				flex: 1;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				display: flex;
				align-items: center;
				flex-wrap: nowrap;
			}
		}

		&.link-tree-expand {
			& > .link-tree-node-content-wrapper > .link-tree-node-icon {
				transform: rotate(180deg);
			}
		}
	}

	@include themeify {
		.link-tree-node {
			.link-tree-node-content-wrapper {
				&:hover {
					background-color: pl-var(color-primary-light);
					color: pl-var(color-primary);
				}
			}
		}
	}
</style>
